import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { getCountryOptions } from "../../services/geoService";

const useDark = () => {
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    const check = () =>
      document.body.classList.contains("dark-mode") ||
      document.querySelector(".app")?.classList.contains("dark-mode");
    setIsDark(check());
    const target = document.querySelector(".app") || document.body;
    const obs = new MutationObserver(() => setIsDark(check()));
    obs.observe(target, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return isDark;
};

const SelectCountry = ({
  value,
  onChange,
  isDisabled = false,
  placeholder = "Seleccione país...",
}) => {
  const isDarkMode = useDark();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const customStyles = useMemo(
    () => ({
      control: (p, s) => ({
        ...p,
        minHeight: 38,
        backgroundColor: isDarkMode ? "#1e1e2f" : "#fff",
        borderColor: s.isFocused ? "#6c63ff" : isDarkMode ? "#444" : "#ced4da",
        boxShadow: s.isFocused ? "0 0 0 0.2rem rgba(108,99,255,.25)" : "none",
      }),
      menu: (p) => ({
        ...p,
        backgroundColor: isDarkMode ? "#1e1e2f" : "#fff",
        zIndex: 20000,
      }),
      menuPortal: (b) => ({ ...b, zIndex: 20000 }),
      singleValue: (p) => ({ ...p, color: isDarkMode ? "#fff" : "#000" }),
      option: (p, s) => ({
        ...p,
        backgroundColor: s.isSelected
          ? "#6c63ff"
          : s.isFocused
          ? isDarkMode
            ? "#2c2c3e"
            : "#f0f0f0"
          : isDarkMode
          ? "#1e1e2f"
          : "#fff",
        color: isDarkMode ? "#fff" : "#000",
        cursor: "pointer",
      }),
      placeholder: (p) => ({ ...p, color: isDarkMode ? "#aaa" : "#888" }),
      input: (p) => ({ ...p, color: isDarkMode ? "#fff" : "#000" }),
    }),
    [isDarkMode]
  );

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const { options } = await getCountryOptions();
        if (mounted) setOptions(options);
      } catch {
        if (mounted) setOptions([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Select
      styles={customStyles}
      placeholder={placeholder}
      isClearable
      isDisabled={isDisabled || loading}
      isLoading={loading}
      menuPortalTarget={document.body}
      options={options}
      value={options.find((o) => o.value === value) || null}
      onChange={(opt) => onChange(opt?.value || "")}
    />
  );
};

export default SelectCountry;
